import React from 'react';

const LoadingState = () => {
  // Create an array with 5 items for skeleton loading
  const skeletonItems = Array.from({ length: 5 }, (_, index) => index);

  return (
    <div className="divide-y divide-gray-100 animate-pulse">
      {skeletonItems.map((item) => (
        <div key={item} className="p-4">
          <div className="flex items-start mb-2">
            <div className="flex-1">
              <div className="h-5 bg-gray-200 rounded w-1/3 mb-2"></div>
              <div className="h-3 bg-gray-200 rounded w-1/4"></div>
            </div>
            <div className="h-3 bg-gray-200 rounded w-16"></div>
          </div>
          <div className="h-4 bg-gray-200 rounded w-full mt-2"></div>
          <div className="h-4 bg-gray-200 rounded w-3/4 mt-1"></div>
        </div>
      ))}
    </div>
  );
};

export default LoadingState;